import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import $ from 'jquery';
import moment from 'moment';
import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import Select from "react-select";

import * as yup from 'yup';
import calLogo from '../../assets/images/calender.svg';
import chevRight from '../../assets/images/chev-right.svg';
import Checkbox from "../../components/layouts/CheckBox";
import Button from "../../components/ui/Button";
import { ApiConstants } from "../../constants/ApiConstants";
import { HOUSEHOLD_TYPES } from "../../constants/Constants";
import ValidationMessage from "../../constants/ValidationMessage";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { isDateFinalized, setDateHelper } from "../../utils/Helper";


interface transactionFilterInputs {
    date: Date | null;
    amount: number | "";
    method: { value: string; label: string };
    payer: { value: string; label: string };
    recipient: { value: string; label: string } | null;
    description: string;
    username: string;
};

const loggedInUser = [{ value: "me", label: "Me" }, { value: "-1", label: "Joint Account" }];


const getSchema = (checks: any) =>
    yup.object().shape({
        date: checks.date
            ? yup
                .date()
                .nullable()
                .required("Date is required")
            : yup.string().nullable(),

        amount: checks.amount
            ? yup.string()
                .required(ValidationMessage.Field("amount"))
                .test(
                    'amount-greater-than-zero',
                    ValidationMessage.Field("amount more than 0"),
                    function (value: any) {
                        if (!value) return false;
                        const numValue = parseFloat(value);
                        return numValue > 0;
                    }
                )
            : yup.string().nullable(),

        payer: checks.payer
            ? yup.object().nullable().required("Payer is required")
            : yup.object().nullable(),

        recipient: checks.recipient
            ? yup.object().nullable().required("Recipient is required")
            : yup.object().nullable(),

        description: checks.description
            ? yup.string().max(200, "Description must be less than 200 characters")
            : yup.string().nullable(),
    });

const editPaymentRecordValidation: any = yup.object().shape({
    date: yup
        .date()
        .nullable()
        .required("Date is required"),
    amount: yup
        .number()
        .typeError("Amount must be a number")
        .positive("Amount must be greater than zero")
        .required("Amount is required"),
    payer: yup.object().required("Payer is required"),
    recipient: yup.object().nullable().required("Recipient is required"),
    description: yup
        .string()
        .test(
            "no-more-than-6-consecutive-digits",
            "Please do not enter more than 6 consecutive numbers.",
            (value) => {
                if (!value) return true; // allow empty
                return !/\d{7,}/.test(value); // fail if 6+ digits in a row
            }
        ),
});

const EditAllTransaction = ({ hhMembers, members, editTransaction, onCancel, onSuccess }: any) => {

    const hh_members = hhMembers?.data?.data

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const updateAllTransaction = useMakeRequest();

    const [editFields, setEditFields] = useState({
        date: true,
        amount: true,
        payer: true,
        receiver: true,
        description: true,
    });


    const recepientOptions = members;

    const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<transactionFilterInputs>({
        mode: 'onChange',
        resolver: yupResolver(getSchema(editFields)) as any,
    });

    const onSubmit = (payload: any) => {
        console.log("editTransaction; ", editTransaction)
        console.log("payload; ", payload)
        console.log("editFields; ", editFields)

        const updatedArray = editTransaction.map((item: any) => {
            const updatedItem: any = {
                ...item,
                transaction_id: item?.id,
                method: item?.method,
                from_id: item.payer,
                to_id: item.receiver,
                new_date: null,
                is_deleted: 0,
            };

            console.log("updatedItem: ", updatedItem)

            if (editFields.amount) {
                updatedItem.amount = payload?.amount;
            }

            if (editFields.description) {
                updatedItem.description = payload?.description || item.desc;
            }

            if (editFields.date) {
                updatedItem.payment_date = payload?.date;
            }
            if (editFields.payer) {
                updatedItem.from_id = payload?.payer?.value === "me" ? profile?.id : payload?.payer?.value;
            }

            if (editFields.receiver) {
                updatedItem.to_id = payload?.recipient?.value;
            }

            return updatedItem;
        });

        console.log("updatedArray; ", updatedArray)

        updateAllTransaction.makeRequest({
            url: ApiConstants?.allUpdateTransaction,
            payload: {
                transactions: updatedArray
            },
        });



        // updateAllTransaction.makeRequest({
        //     url: ApiConstants.allUpdateTransaction,
        //     payload: {
        //         transaction_id: editTransaction?.id,
        //         amount: payload.amount,
        //         description: payload.description,
        //         method: editTransaction?.method,
        //         payment_date: payload?.date,
        //         from_id: payload?.payer?.value === "me" ? profile?.id : payload?.payer?.value,
        //         to_id: payload?.recipient?.value,
        //     }
        // })
    }

    function getNameById(id: number) {
        const member = hh_members.find((item: any) => item.user?.id === id);
        return member ? member.user.name : null;
    }

    useEffect(() => {
        if (editTransaction) {
            console.log("editTransaction: ", editTransaction)
            editTransaction?.date && setValue('date', editTransaction?.date)
            editTransaction?.amount && setValue('amount', editTransaction?.amount)
            editTransaction?.payer && setValue('payer', {
                value: editTransaction?.payer,
                label: profile?.id === editTransaction?.payer ? 'Me' : editTransaction?.paid_by?.label
            })
            editTransaction?.receiver && setValue('recipient', {
                value: editTransaction?.receiver,
                label: profile?.id === editTransaction?.receiver ? 'Me' : getNameById(editTransaction?.receiver)
            })
            editTransaction?.description && setValue('description', editTransaction?.description)
        }
    }, [editTransaction])


    useEffect(() => {
        if (updateAllTransaction?.status) {
            onSuccess();
            reset();
            $('.btn-close-modal').click()
            setTimeout(() => {
                toast.success('Transaction updated successfully');
            }, 500);
        }
    }, [updateAllTransaction?.status])

    const toggleField = (field: keyof typeof editFields) => {
        setEditFields((prev) => {
            const newState = { ...prev, [field]: !prev[field] };
            return newState;
        });
    };

    return (
        <div className="modal fade bottom-sheet-modal" id="EditAllTransactionModal" tabIndex={-1} aria-labelledby="EditAllTransactionModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true" >

            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="EditAllTransactionModal">Edit Payments</h1>
                    </div>
                    <span className="form-title-control">
                        If a box is checked, the field will be changed for all payments selected. If a box is not checked, the field will not be changed.
                    </span>

                    <div className="modal-body mt-3">
                        <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
                            {/* Date */}
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_date"}
                                        labelText={"Edit Date"}
                                        checked={editFields.date}
                                        onChange={() => toggleField("date")}
                                    />
                                    {/* <label className="form-label d-block">Date</label> */}
                                    <DatePicker
                                        className="form-control"
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={watch("date")}
                                        showIcon
                                        icon={
                                            <>
                                                <img className="calIcon" src={calLogo} alt="" />
                                            </>
                                        }
                                        onChange={(date) => setValue("date", date)}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="date"
                                        render={({ message }) => (
                                            <p className="valid-error">{message}</p>
                                        )}
                                    />
                                </div>
                            </div>

                            {/* Amount */}
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_amount"}
                                        labelText={"Edit Amount"}
                                        checked={editFields.amount}
                                        onChange={() => toggleField("amount")}
                                    />
                                    {/* <label className="form-label d-block">Amount</label> */}
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter amount"
                                        {...register("amount")}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="amount"
                                        render={({ message }) => (
                                            <p className="valid-error">{message}</p>
                                        )}
                                    />
                                </div>
                            </div>

                            {/* Payer (logged-in user) */}
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_payer"}
                                        labelText={"Edit Payer"}
                                        checked={editFields.payer}
                                        onChange={() => toggleField("payer")}
                                    />
                                    {/* <label className="form-label d-block">Payer</label> */}
                                    <div className="custom-select">
                                        <Select
                                            value={watch("payer")}
                                            onChange={(val) => {
                                                if (val) setValue("payer", val);
                                            }}
                                            options={loggedInUser}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                        />
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        name="payer"
                                        render={({ message }) => (
                                            <p className="valid-error">{message}</p>
                                        )}
                                    />
                                </div>
                            </div>

                            {/* Recipient */}
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_receiver"}
                                        labelText={"Edit Recipient"}
                                        checked={editFields.receiver}
                                        onChange={() => toggleField("receiver")}
                                    />
                                    {/* <label className="form-label d-block">Recipient</label> */}
                                    <div className="custom-select">
                                        <Select
                                            value={watch("recipient")}
                                            onChange={(val) => {
                                                setValue("recipient", val, { shouldValidate: true, shouldTouch: true })
                                            }}
                                            options={recepientOptions}
                                            placeholder="Select recipient"
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            }}
                                        />
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        name="recipient"
                                        render={({ message }) => (
                                            <p className="valid-error">{message}</p>
                                        )}
                                    />
                                </div>
                            </div>

                            {/* Description */}
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_description"}
                                        labelText={"Edit Description"}
                                        checked={editFields.description}
                                        onChange={() => toggleField("description")}
                                    />
                                    {/* <label className="form-label d-block">Description</label> */}
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter description"
                                        {...register("description")}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="description"
                                        render={({ message }) => (
                                            <p className="valid-error">{message}</p>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className='pb-4 d-flex gap-3'>
                                <button className='custom-grayed-btn modal-light-btn btn-close-modal' style={{ width: "50%" }} data-bs-dismiss="modal" aria-label="Close" disabled={updateAllTransaction?.loading} type="button" onClick={onCancel}>Cancel</button>
                                <Button className='com-btn' type="submit" text="submit" style={{ width: "50%" }} loading={updateAllTransaction?.loading}>Save</Button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default EditAllTransaction